import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Cookie/Cookie.tsx");
